import {Component, EventEmitter, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";

export interface Config1733Form {
  token: string;
}

@Component({
  selector: 'ms-form-config-1733',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './form-config-1733.component.html',
  styleUrl: './form-config-1733.component.scss'
})
export class FormConfig1733Component {

  @Output() formChange = new EventEmitter<Config1733Form>();

  public form: Config1733Form = {
    token: '',
  };

  public onFieldChange() {
    this.formChange.emit({...this.form});
  }
}
